export const stats = [
  { value: '+180', label: 'cuidadoras usando el protocolo' },
  { value: '3', label: 'Volúmenes completos' },
  { value: '5', label: 'Bonos incluidos' },
  { value: '4.9/5', label: 'calificación' },
];

export const testimonials = [
  {
    initials: 'AN',
    name: 'Alejandra N.',
    place: 'La Plata',
    quote:
      'Después de la discusión con mi papá, no sabía cómo acercarme. El protocolo me dio la estructura que faltaba. Ahora puedo hablarle sin que vuelva a escalar.',
  },
  {
    initials: 'DL',
    name: 'Daniela L.',
    place: 'Córdoba',
    quote:
      'Usé las tarjetas de primer acercamiento y funcionó. Mi mamá me escuchó diferente porque llegué preparada, no improvisando.',
  },
  {
    initials: 'VS',
    name: 'Viviana S.',
    place: 'Mendoza',
    quote:
      'El semáforo de tensión me enseñó a reconocer cuándo es buen momento para hablar. Eso me calmó mucho porque ahora sé qué hacer.',
  },
];

export const extendedTestimonials = [
  {
    name: 'Gabriela M.',
    place: 'Rosario',
    quote:
      '“El traductor de reproches cambió todo. Mi mamá me escuchó diferente porque no empecé atacando. Por primera vez sentí que realmente comprendía lo que necesitaba.”',
  },
  {
    name: 'Romina T.',
    place: 'Tucumán',
    quote:
      '“El protocolo me hizo ver patrones que no había notado. Ahora sé exactamente qué está pasando y qué puedo cambiar en mi comunicación.”',
  },
  {
    name: 'Marcela V.',
    place: 'Bahía Blanca',
    quote:
      '“No creía que un protocolo pudiera hacer diferencia, pero llegué preparada y toda la relación con mi pareja mejoró significativamente.”',
  },
  {
    name: 'Silvina P.',
    place: 'Salta',
    quote:
      '“No es mi culpa. Tengo herramientas ahora y eso me da mucha más calma en la casa.”',
  },
];

export const purchases = [
  { name: 'Alejandra N.', place: 'La Plata' },
  { name: 'Daniela L.', place: 'Córdoba' },
  { name: 'Gabriela M.', place: 'Rosario' },
  { name: 'Silvina P.', place: 'Salta' },
];
